"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DefaultUserMenu", {
  enumerable: true,
  get: function get() {
    return _DefaultUserMenu.default;
  }
});
Object.defineProperty(exports, "EVENT_USER_LANGUAGE_CHANGED", {
  enumerable: true,
  get: function get() {
    return _api.EVENT_USER_LANGUAGE_CHANGED;
  }
});
Object.defineProperty(exports, "EVENT_USER_LOGGED_OUT", {
  enumerable: true,
  get: function get() {
    return _api.EVENT_USER_LOGGED_OUT;
  }
});
Object.defineProperty(exports, "EVENT_USER_PROFILE_CHANGED", {
  enumerable: true,
  get: function get() {
    return _api.EVENT_USER_PROFILE_CHANGED;
  }
});

var _DefaultUserMenu = _interopRequireDefault(require("./components/DefaultUserMenu"));

var _api = require("./constants/api");

if (typeof window !== 'undefined') {
  window.RioUserMenuSnapshot = {
    DefaultUserMenu: _DefaultUserMenu.default,
    EVENT_USER_LANGUAGE_CHANGED: _api.EVENT_USER_LANGUAGE_CHANGED,
    EVENT_USER_LOGGED_OUT: _api.EVENT_USER_LOGGED_OUT,
    EVENT_USER_PROFILE_CHANGED: _api.EVENT_USER_PROFILE_CHANGED
  };
}